<template>
    <DataTable
        :header="$t('widgeterReportsPages.pageStats')"
        :error="error"
        :items="itemsFormatted"
        :fields="fields"
        :total-rows="items.length"
        :loading="loading"
        :current-page.sync="currentPage"
        :per-page.sync="perPage"
        :sort-by.sync="sortBy"
        :sort-direction.sync="sortDirection"
    >
        <template #headerSide>
            <JsonToCsv
                class="ml-3"
                :disabled="loading || !items.length"
                :items="itemsFormatted"
                :fields="exportFields"
                :labels="exportLabels"
                :name="exportFilename"
            >
                {{ $t('exportToExcel') }}
            </JsonToCsv>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import JsonToCsv from '@/components/common/JsonToCsv.vue';

    export default {
        name: 'SiteStatistics',
        components: {
            DataTable,
            JsonToCsv,
        },
        props: {
            spaceIds: {
                type: Array,
                required: true,
            },
            timeRange: {
                type: Object,
                required: true,
            },
            filtersLoading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                sortBy: 'space.name',
                perPage: 25,
                currentPage: 1,
                sortDirection: 'ASC',
            };
        },
        computed: {
            fields() {
                return [
                    {
                        key: 'space.name',
                        label: this.$t('widgeterReportsPages.space'),
                        sortable: true,
                    },
                    {
                        key: 'impressions',
                        label: this.$t('widgeterReportsPages.impressions'),
                        sortable: true,
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                    {
                        key: 'clicks',
                        label: this.$t('widgeterReportsPages.clicks'),
                        sortable: true,
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                    {
                        key: 'orders',
                        label: this.$t('widgeterReportsPages.transactions'),
                        sortable: true,
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                    {
                        key: 'conversion',
                        label: this.$t('widgeterReportsPages.conversion'),
                        sortable: true,
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                    {
                        key: 'amount',
                        label: this.$t('widgeterReportsPages.transactionAmount'),
                        sortable: true,
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                    {
                        key: 'commission',
                        label: this.$t('widgeterReportsPages.commission'),
                        sortable: true,
                        tdClass: 'text-right',
                        thClass: 'text-right',
                    },
                ];
            },
            campaignId() {
                return this.$store.getters['campaigns/getCurrentCampaign']?.id;
            },
            isRoleAdvertiser() {
                return this.$store.getters['auth/isRoleAdvertiser'];
            },
            requestParams() {
                return {
                    spaces: this.spaceIds.join(','),
                    startDate: this.timeRange.startDate,
                    endDate: this.timeRange.endDate,
                    campaigns: this.campaignId || '',
                };
            },
            apiParams() {
                return { requestParams: this.requestParams };
            },
            error() {
                return this.$store.getters['userStats/getError']('spaceStats');
            },
            loading() {
                return this.$store.getters['userStats/getLoading']('spaceStats') || this.filtersLoading;
            },
            space() {
                return this.$store.getters['userStats/getSpaceStats'];
            },
            items() {
                return this.space.items || [];
            },
            exportFields() {
                return this.fields.map(item => item.key);
            },
            exportLabels() {
                return Object.fromEntries(this.fields.map(item => [item.key, item.label]));
            },
            exportFilename() {
                const from = this.timeRange?.startDate ? `-from-${this.$format.date(this.timeRange.startDate)}` : '';
                const to = this.timeRange?.endDate ? `-to-${this.$format.date(this.timeRange.endDate)}` : '';
                return `reports-pages${from}${to}.csv`;
            },
            itemsFormatted() {
                return this.items.map(item => ({
                    ...item,
                    commission: this.$format.currency(item.commission),
                    amount: this.$format.currency(item.amount),
                    conversion: this.$format.percent((item.orders / item.clicks) * 100),
                }));
            },
        },
        watch: {
            apiParams: {
                handler: 'fetchData',
            },
        },
        methods: {
            fetchData() {
                if (!this.requestParams.spaces || !this.requestParams.startDate || !this.requestParams.endDate) return;
                this.$store.dispatch('userStats/fetchSpaceStats', this.apiParams);
            },
        },
    };
</script>
